export const getBaseURL = () => {
    if (typeof window !== 'undefined') {
        const h = window.location.hostname;
        if (h === 'app.trogiang.online' || h.endsWith('.trogiang.online')) {
            return 'https://api.trogiang.online/api/v1';
        }
        if (h === 'app-trogiang.icitech.net' || h.endsWith('.icitech.net')) {
            return 'https://api-trogiang.icitech.net/api/v1';
        }
        if (h !== 'localhost' && h !== '127.0.0.1') {
            return `${window.location.protocol}//${h}:8000/api/v1`;
        }
    }
    if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
    return 'http://localhost:8000/api/v1';
};

export const baseURL = getBaseURL();

export const getMarketingURL = () => {
    let url = process.env.REACT_APP_MARKETING_URL;
    if (!url) {
        if (typeof window !== 'undefined') {
            const h = window.location.hostname;
            if (h === 'app.trogiang.online' || h.endsWith('.trogiang.online')) {
                url = 'https://trogiang.online';
            } else if (h === 'app-trogiang.icitech.net' || h.endsWith('.icitech.net')) {
                url = 'https://trogiang.icitech.net';
            } else {
                url = 'http://localhost:3002';
            }
        } else {
            url = 'http://localhost:3002';
        }
    }
    return url.replace(/\/+$/, '');
};

export const marketingURL = getMarketingURL();

export const getSubdomainURL = (domain?: string | null, useHttps: boolean = false): string | null => {
    if (!domain || !domain.trim()) return null;
    const clean = domain.trim();
    if (clean.includes('://')) return clean;

    const protocol = useHttps ? 'https' : 'http';

    const isLocal = typeof window !== 'undefined' && (
        window.location.hostname === 'localhost' ||
        window.location.hostname === '127.0.0.1' ||
        window.location.hostname.endsWith('.localhost')
    );

    if (isLocal) {
        const sub = clean.replace('.trogiang.online', '').replace('.localhost', '');
        return `http://${sub}.localhost:3002`;
    }

    if (clean.includes('.')) {
        return `${protocol}://${clean}`;
    }
    return `${protocol}://${clean}.trogiang.online`;
};

export const getOrgPublicUrl = (org?: { domain?: string | null; slug?: string | null; id?: string | null; website?: string | null; use_https?: boolean | null } | null): string => {
    if (!org) return '#';
    // Chỉ dùng Subdomain URL khi trung tâm có cấu hình domain riêng
    if (org.domain && org.domain.trim()) {
        const subUrl = getSubdomainURL(org.domain, Boolean(org.use_https));
        if (subUrl) return subUrl;
    }
    // Khi không cấu hình subdomain, URL của trung tâm luôn là /org/{slug}
    if (org.slug || org.id) {
        return `${marketingURL}/org/${org.slug || org.id}`;
    }
    if (org.website) {
        return org.website.startsWith('http') ? org.website : `https://${org.website}`;
    }
    return '#';
};

